import { render, staticRenderFns } from "./DialogListItems.vue?vue&type=template&id=b1e49b8c"
import script from "./DialogListItems.vue?vue&type=script&lang=js"
export * from "./DialogListItems.vue?vue&type=script&lang=js"
import style0 from "./DialogListItems.vue?vue&type=style&index=0&id=b1e49b8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports